import { Box } from '@mui/material';
import { Typography } from '../../primitives/typography/typography';
import { ReactNode } from 'react';

export interface ErrorStateProps {
  message?: ReactNode;
  padding?: number;
}

export const ErrorState = ({
  message = 'Something went wrong. Please try again later.',
  padding = 3,
}: ErrorStateProps) => (
  <Box sx={{ p: padding, textAlign: 'center' }}>
    <Typography.BodyEmphasised sx={{ color: 'error.main' }}>{message}</Typography.BodyEmphasised>
  </Box>
);
